module.exports = __webpack_public_path__ + "img/ALSH_SEJOUR_ETE.2ef58194.svg";